import { checkLocal, postAPIData } from "utils/api";

let count = 0;
let cachedData: any = null; // Store last fetched data to prevent unnecessary updates

export const getReportData = async (mode = 'new') => {
	try {
		if (checkLocal()) {
			count++;
			const newData = require(count % 2 ? './dummy-1.json' : './dummy.json');

			// Only return new data if it has actually changed
			if (JSON.stringify(newData) !== JSON.stringify(cachedData)) {
				cachedData = newData;
				return newData;
			}
			return cachedData;
		}

		const response = await postAPIData('dbselect', { mode });

		// Prevent unnecessary updates by checking if data has changed
		if (JSON.stringify(response?.data) !== JSON.stringify(cachedData)) {
			cachedData = response?.data;
			return response?.data;
		}

		return cachedData; // Return cached data if nothing changed
	} catch (error) {
		console.error(error);
		return cachedData || {}; // Return cached data in case of an error
	}
};
